/*
 * Copyright (c) 2021.
 * 2iPartners SàRL and/or its affiliates.
 * All rights reserved.
 *
 * 2iPartners SàRL
 * Route de Compois 24,
 * 1252 Meinier
 * Suisse
 *
 * tel : +41 22 735 97 07
 */

import {NgModule} from '@angular/core';
import {CommonModule, NgOptimizedImage} from '@angular/common';
import {CDKModule} from '../../cdk.module';
import {MaterialModule} from '../../material.module';
import {
  DisplayRemovalPointDetailsComponent
} from './display-removal-point-details/display-removal-point-details.component';
import {DisplayDocsToGiveComponent} from './display-docs-to-give/display-docs-to-give.component';
import {DisplayAnimalsNotAddedComponent} from './display-animals-not-added/display-animals-not-added.component';
import {DisplayThirdPartyCsoComponent} from './display-third-party-cso/display-third-party-cso.component';
import {FormsModule} from '@angular/forms';
import {DisplayContactComponent} from './display-contact/display-contact.component';
import {DisplayLogosAvailableComponent} from './display-logos-available/display-logos-available.component';
import {DisplayLogosProvaltComponent} from './display-logos-provalt/display-logos-provalt.component';
import {DisplayThirdPartiesComponent} from './display-third-parties/display-third-parties.component';
import {DisplayGoHomeComponent} from './display-go-home/display-go-home.component';
import {DisplayLogosBrowsersComponent} from './display-logos-browsers/display-logos-browsers.component';

@NgModule({
  declarations: [
    DisplayAnimalsNotAddedComponent,
    DisplayContactComponent,
    DisplayDocsToGiveComponent,
    DisplayGoHomeComponent,
    DisplayLogosAvailableComponent,
    DisplayLogosBrowsersComponent,
    DisplayLogosProvaltComponent,
    DisplayRemovalPointDetailsComponent,
    DisplayThirdPartyCsoComponent,
    DisplayThirdPartiesComponent
  ],

  exports: [
    DisplayAnimalsNotAddedComponent,
    DisplayContactComponent,
    DisplayDocsToGiveComponent,
    DisplayGoHomeComponent,
    DisplayLogosAvailableComponent,
    DisplayLogosBrowsersComponent,
    DisplayLogosProvaltComponent,
    DisplayRemovalPointDetailsComponent,
    DisplayThirdPartyCsoComponent,
    DisplayThirdPartiesComponent
  ],
    imports: [
        CDKModule,
        CommonModule,
        FormsModule,
        MaterialModule,
        NgOptimizedImage
    ]
})

export class DisplaysModule {
}
